import { Modal, Skeleton } from '@execonline-inc/execonline-ui';
import { OpenableAction } from '@execonline-inc/execonline-ui/dist/hooks/useOpenable/Types';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import { learningCollectionsStore } from '../../../../../../../../stores/LearningCollectionsStore';
import { useLearningCollectionDetails } from '../../../../../../../LearningCollectionDetailsContext';
import { ProductCollectionResource } from '../../../Types';
import ExperienceModalHeader from './ExperienceModalHeader';
import EnhancedModalBody from './EnhancedModalBody';
import FilterContext from '../../../Filters/FilterContext';

interface Props {
  productCollection: ProductCollectionResource;
  index: number;
  isOpen: boolean;
  onClose: OpenableAction;
}

function ModalWithExperiences({ onClose, productCollection, index, isOpen }: Props) {
  const { state } = learningCollectionsStore;
  const detailsState = useLearningCollectionDetails();

  switch (state.kind) {
    case 'errored':
      return <T kind="Something went wrong" />;
    case 'loading':
      return <Skeleton className="w-36" variant="rectangle" size="sm" />;
    case 'ready':
      return (
        <Modal
          size="6xl"
          open={isOpen}
          onClose={onClose}
          outsidePress={true}
          classNames={{ closeButton: 'hidden' }}
          className="flex flex-col !max-w-[1200px] h-[calc(100vh-4rem)] overflow-hidden"
          data-intercom-target="builder-v2-course-catalog-modal"
        >
          <ExperienceModalHeader
            onClose={onClose}
            sectionName={productCollection.payload.name}
            addedCount={productCollection.payload.experiences.length}
          />
          <div className="flex-1 overflow-hidden">
            <FilterContext resource={state.data.resource}>
              <EnhancedModalBody
                resource={state.data.resource}
                productCollection={productCollection}
                details={detailsState}
                index={index}
                onClose={onClose}
              />
            </FilterContext>
          </div>
        </Modal>
      );
  }
}

export default observer(ModalWithExperiences);
